import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import AdventTextDoor from './textDoor';
import { formatDate } from '../../../lib/clubOps';

/**
 * Convention («Stevne») door: the greeting layout plus the convention's title and date, the
 * member's status (registered / participated, checked by the backend) and a link to the
 * convention page. Registration or a result marks the door done (challengeDone) on the backend.
 */
@observer
class AdventConventionDoor extends Component {
    render() {
        const { door = {} } = this.props;
        const content = door.content || {};
        const conventionId = parseInt(content.convention, 10) || 0;
        const done = !!(content.registered || content.participated);
        return (
            <AdventTextDoor {...this.props}>
                {content.conventionTitle ? (
                    <div class='card mb-3'>
                        <div class='card-body'>
                            <div class='d-flex align-items-center gap-2 mb-1'>
                                <span style='font-size: 1.6rem;'>🎯</span>
                                <div class='fs-5 fw-bold'>{content.conventionTitle}</div>
                            </div>
                            {content.startDate ? (
                                <div class='text-body-secondary mb-2'>
                                    <i class='fa-regular fa-calendar me-2' />{formatDate(content.startDate)}
                                </div>
                            ) : null}
                            {content.participated ? (
                                <div class='alert alert-success py-2 mb-2'>
                                    <i class='fa-solid fa-check me-2' />
                                    <Text id='adventCalendar.conventionParticipated'>You took part ✓</Text>
                                </div>
                            ) : null}
                            {content.registered && !content.participated ? (
                                <div class='alert alert-success py-2 mb-2'>
                                    <i class='fa-solid fa-check me-2' />
                                    <Text id='adventCalendar.conventionRegistered'>You are registered ✓</Text>
                                </div>
                            ) : null}
                            {conventionId > 0 ? (
                                <a href={`/convention/${conventionId}`} class={`btn ${done ? 'btn-outline-primary' : 'btn-primary'}`}>
                                    <i class='fa-solid fa-arrow-right me-2' />
                                    {done
                                        ? <Text id='adventCalendar.conventionView'>View the convention</Text>
                                        : <Text id='adventCalendar.conventionRegister'>Register</Text>}
                                </a>
                            ) : null}
                            {!done ? (
                                <div class='small text-body-secondary mt-2'>
                                    <Text id='adventCalendar.conventionDoneHint'>Registering or taking part gives you an extra ticket in the draw.</Text>
                                </div>
                            ) : null}
                        </div>
                    </div>
                ) : (
                    <div class='alert alert-warning'>
                        <Text id='adventCalendar.conventionMissing'>The convention no longer exists.</Text>
                    </div>
                )}
            </AdventTextDoor>
        );
    }
}

export default AdventConventionDoor;
